import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import {ApiBaseUrl, SnackbarOptions} from '../../../constants';
import { useAuth } from "../../../context/auth";
import { trackPromise } from 'react-promise-tracker';
import {useSnackbar} from 'react-simple-snackbar'
import {
    useStripe,
    useElements,
    CardNumberElement,
    CardCvcElement,
    CardExpiryElement
} from "@stripe/react-stripe-js";


const useOptions = () => {
    const options = useMemo(
        () => ({
            style: {
                base: {
                    fontSize:"16px",
                    color: "#ffffff",
                    letterSpacing: "0.025em"
                },
                invalid: {
                    color: "#cc0000"
                }
            }
        }),[]
    );

    return options;
};

const SplitForm = (props) => {
    const [openSnackbar] = useSnackbar(SnackbarOptions)
    let history = useHistory();
    const {token} = useAuth();
    const bearerToken = token;
    const [lastUsedPromoState, setLastUsedPromoState] = useState({
        code: ''
    });
    const [lastAppliedPromoState, setLastAppliedPromoState] = useState({
        code: ''
    });
    const [promoState, setPromoState] = useState({
        applied: false,
        consumer_order_cost: false,
        reserve_price: false,
        still_owed: false

    });
    const stripe = useStripe();
    const elements = useElements();
    const options = useOptions();

    const handleSubmit = async event => {
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }

        /*const payload = await stripe.createPaymentMethod({
            type: "card",
            card: elements.getElement(CardNumberElement)
        });
        console.log("[PaymentMethod]", payload);
        */
        const {error, token} = await stripe.createToken(
            elements.getElement(CardNumberElement)
        );

        if(error) {
            openSnackbar(error.message);
            return;
        }

        let paymentBody = 'id='+props.id+'&paytoken='+token.id;
            if(promoState.applied)
                paymentBody += '&promo_code='+lastUsedPromoState.code;

        trackPromise(
            fetch(ApiBaseUrl+"/consumer/reserve",
            {
                method: 'POST',
                body: paymentBody,
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+bearerToken
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    openSnackbar(result.message);
                    if(result.success){
                        history.replace(process.env.PUBLIC_URL+'/oneday/entry-pass/'+result.data._id);
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {

                }
            )
        );
    };

    const handlePromoChange = (event) => {
        setLastUsedPromoState({
            code: event.target.value
        });
    }

    const applyLastPromo = (event) => {
        setLastUsedPromoState({
            code: props.last_used_promo
        });
        applyPromo(props.last_used_promo)
    }

    const hangleApplyPromo = (event) => {
        event.preventDefault()
        applyPromo(lastUsedPromoState.code)
    }

    const applyPromo = (code) => {
        if(!code) {
            openSnackbar('Please enter promo code.');
            return false
        }
        trackPromise(
        fetch(ApiBaseUrl+"/consumer/apply_promo_reserve/"+props.id,
            {
                method: 'POST',
                body: 'promo_code='+code,
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+bearerToken
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result.success === false){
                        openSnackbar(result.message);
                        setLastUsedPromoState({
                            code: lastAppliedPromoState.code
                        });
                    }
                    else {
                        setLastAppliedPromoState({
                            code: code
                        });
                        localStorage.setItem('silverbackLastUsedPromo', code);
                        setPromoState({
                            applied: true,
                            consumer_order_cost: result.data.consumer_order_cost,
                            reserve_price: result.data.reserve_price,
                            still_owed: result.data.still_owed
                        });
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {

                }
            )
        );
    }

    return (
        <div className="row">
            <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog custom-w-400" role="document">
                    <div className="modal-content p-4">
                        <div className="modal-header d-flex align-items-center pl-0">
                            <h5 className="modal-title pl-0 payment-modal-text" id="exampleModalLabel">Apply Promo
                                Code</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body px-0">
                            <input type="text" onChange={handlePromoChange} value={lastUsedPromoState.code} className="form-control" aria-label="Small"
                                   aria-describedby="inputGroup-sizing-sm" placeholder="Enter Promo Code"/>
                        </div>
                        <div className="modal-footer mt-4">
                            <button onClick={hangleApplyPromo} type="button" className="btn btn-secondary" data-dismiss="modal">Apply</button>
                            <button data-dismiss="modal" aria-label="Close" type="button" className="btn btn-primary red-bg">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-7 col-md-7 col-12 px--xs-0">
        <form autoComplete="off" onSubmit={handleSubmit} className="card-form-solid">
            <div className="ro">
                <div className="payment-container">
                    <div className="payment-box">
                        <div className="new-card-add-row">
                            <p className="text-white">Enter card details</p>
                            <div className="row">
                                {/*<div className="col-xl-12">
                                    <div className="new_card_number">
                                        <div className="card_img">
                                            <img src={`${process.env.PUBLIC_URL}/image/cart-cart-img-1.png`} alt="card"/>
                                        </div>
                                        <span className="card-num">Card Number</span>
                                    </div>
                                </div>*/}
                                <div className="col-xl-12">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <CardNumberElement options={options}/>
                                        </div>
                                        <div className="col-lg-8 col-12 col-md-12">
                                            <CardExpiryElement options={options}/>
                                        </div>
                                        <div className="col-lg-4 col-12 col-md-12">
                                            <CardCvcElement className="w-100" options={options}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 text-lg-right text-center">
                                    <div className="cart_pay">
                                        <button disabled={!stripe} className="grad-on pay_cart_btn text-uppercase font-weight-bold" type="submit">Pay</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
            </div>

            <div className="col-lg-5 col-md-5 col-12 px--xs-0">
                <div className="payment-detail-box">
                    <div className="card-deposite-outer grad-on">
                        <div className="card-deposite-cols card_reserve_deal">
                            <p>Pay deposit to Reserve Deal: {promoState.applied ? (<React.Fragment><span className="strike-trough font-weight-bold">${props.consumer_order_cost-props.consumerprice}</span> <span className="pl-3 font-weight-bold reserve_deposit">${promoState.reserve_price}</span></React.Fragment>) : (<span className="pl-3 font-weight-bold reserve_deposit">${props.consumer_order_cost-props.consumerprice}</span>) }</p>
                        </div>

                        <div className="card-deposite-cols card-deposite-right">
                            <p>Full Price :{promoState.applied ? (<React.Fragment><span className="strike-trough font-weight-bold pl-2">${props.consumer_order_cost}</span><span className="pl-3 font-weight-bold card_price">${promoState.consumer_order_cost}</span></React.Fragment>) : (<span className="pl-3 font-weight-bold card_price">${props.consumer_order_cost}</span>) }</p>
                        </div>
                        <div className="card-deposite-cols card-deposite-right">
                            <p>Still Owed :{promoState.applied ? (<React.Fragment><span className="strike-trough font-weight-bold pl-2">${props.consumerprice}</span><span className="pl-3 font-weight-bold card_price">${promoState.still_owed}</span></React.Fragment>) : (<span className="pl-3 font-weight-bold card_price">${props.consumerprice}</span>)}</p>
                        </div>
                    </div>

                    {props.consumerprice > 20 &&
                    <div className="payment-apply-pro-inner">
                        <button type="button" className="btn font-weight-bold" data-toggle="modal"
                                data-target="#exampleModal">Apply promo code
                        </button>
                        {props.last_used_promo &&
                        <div className="prev-proinner">
                            <button onClick={applyLastPromo} className="prev-promo-btn font-weight-bold">Last Used Promo
                                <span>{props.last_used_promo}</span></button>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default SplitForm;
